import { CollectSessionType } from './types'

interface CollectSessionProps {
  collect_session: CollectSessionType
}

export default function CollectSession({ collect_session }: CollectSessionProps) {
  return (
    <div>
      <p className="my-5">
        <strong className="block font-medium mb-1">Community:</strong>
        {collect_session.community_id?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Device:</strong>
        {collect_session.device
          ? `${collect_session.device.name} (${collect_session.device.code}) - ${collect_session.device.status}`
          : collect_session.device_id?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">User:</strong>
        {collect_session.user_id?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Start at:</strong>
        {collect_session.start_at?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">End at:</strong>
        {collect_session.end_at?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Physical amount collected:</strong>
        {collect_session.physical_amount_collected?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Status:</strong>
        {collect_session.status?.toString()}
      </p>
    </div>
  )
}
